/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-15 16:35:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-27 17:58:24
 */
import React, { useState, useEffect } from 'react';
import { ClassifyInfo } from '@src/services';
import './Classification.less';
import { IconFont } from '..';

export interface IClassificationProps {
  /** 文章全部分类 */
  classifyAll: ClassifyInfo[];
  /** 文章分类切换 */
  changeClassifyId: (classifyId: number) => void;
  /** 当前激活的id */
  activeIndex: number;
  className?: string;
}

type Props = IClassificationProps;

export function Classification(props: Readonly<Props>) {
  const { classifyAll, changeClassifyId, activeIndex, className } = props;
  const [activeId, setActiveId] = useState(activeIndex);

  const [scrollX, setScrollX] = useState(0);
  /* 定位左边的值 */
  const [leftStyle, setLeftStyle] = useState({ left: '0' });

  /** 滚动元素 */
  const contentEle: Element = document.querySelector('.classify-content') as Element;
  const contentEleWidth: number = contentEle?.clientWidth || 0;
  const classifyWidth: number =
    document.querySelector('.k-common-classification')?.clientWidth || 0;
  /** 最大的位移 */
  const displacement: number = contentEleWidth - classifyWidth;
  const [boxWidth, setBoxWidth] = useState({ width: '600px' });
  /** 目标移动的位置 (中间变量) */
  let targetLeft = 0;
  /**
   * @description  点击左右icon发生滑动
   */
  const changeScroll = (num: number, size: number) => {
    targetLeft = scrollX + num * size;
    if (targetLeft <= -1 * displacement) {
      targetLeft = -1 * displacement;
    } else if (targetLeft >= 0) {
      targetLeft = 0;
    }
    setScrollX(targetLeft);
    setLeftStyle({ left: `${targetLeft}px` });
  };
  useEffect(() => {
    contentEleWidth < 600 && contentEleWidth > 0 && setBoxWidth({ width: `${contentEleWidth}px` });
  }, [contentEleWidth]);
  useEffect(() => {
    setActiveId(activeIndex);
  }, [activeIndex]);
  /**
   * @description 点击切换激活样式
   */
  const changeActive = (id: number) => {
    setActiveId(id);
    changeClassifyId(id);
  };

  return (
    <div className={`common-presenter k-common-classification ${className}`} style={boxWidth}>
      {scrollX < 0 && contentEleWidth > 600 && (
        <div className="left">
          <IconFont
            type="icon-left-arr"
            className="left-icon"
            onClick={() => {
              changeScroll(2, 200);
            }}
          />
        </div>
      )}
      <div className="classify-content" style={leftStyle}>
        <span
          className={activeId === 0 ? 'classify active' : 'classify'}
          onClick={() => {
            changeActive(0);
          }}
        >
          全部
        </span>
        {classifyAll.map(item => {
          return (
            <span
              className={item.classifyId === activeId ? 'classify active' : 'classify'}
              key={item.classifyId}
              onClick={() => {
                changeActive(item.classifyId || 0);
              }}
            >
              {item.classifyName}
            </span>
          );
        })}
      </div>

      {scrollX > displacement * -1 && contentEleWidth > 600 && (
        <div className="right">
          <IconFont
            type="icon-right"
            className="right-icon"
            onClick={() => {
              changeScroll(-2, 200);
            }}
          />
        </div>
      )}
    </div>
  );
}

export default Classification;
